import api from "./api";

/**
 * Cancela a assinatura ativa do tenant logado.
 * O `/api` faz parte do baseURL do axios (ver services/api.js), por isso o
 * path aqui começa em `/payments`. Backend: DELETE /api/payments/cancel-subscription.
 * Sucesso: { success, message } · Erro: { error } ou { success:false, message }.
 *
 * @param {{ reason?: string, detail?: string, deregisterNumber?: boolean }} [payload]
 *   motivo opcional do cancelamento e flag opcional `deregisterNumber`. Quando
 *   presentes, vão no body do DELETE (axios exige `{ data }` para enviar body em
 *   requisições DELETE). `deregisterNumber: true` só faz sentido para tenant
 *   tradicional (coexistence === false) com número Meta vinculado; o backend
 *   ignora/avisa para tenants em coexistência.
 */
export const cancelSubscription = (payload) =>
  api.delete(
    "/payments/cancel-subscription",
    payload ? { data: payload } : undefined,
  );

/**
 * Desfaz um cancelamento agendado — volta a assinatura para ACTIVE.
 * Backend: POST /api/payments/undo-cancellation.
 * Sucesso: { success, message, subscriptionStatus: "ACTIVE" }.
 */
export const undoCancellation = () => api.post("/payments/undo-cancellation");

/**
 * Agenda a troca de plano para o próximo ciclo de cobrança.
 * Backend: POST /api/payments/change-plan { newPlanId }.
 * Resposta:
 *   • { status: "scheduled", effectiveDate, newPlan: { name } } — troca agendada.
 *   • { status: "manual_fallback", reason } — sem tokenização; cair no WhatsApp.
 *
 * @param {string} newPlanId id do plano de destino.
 */
export const changePlan = (newPlanId) =>
  api.post("/payments/change-plan", { newPlanId });

/**
 * Lista as faturas da assinatura (read-only).
 * Backend: GET /api/payments/invoices.
 * Cada item: { date, value, status, receiptUrl, description }.
 */
export const getInvoices = () => api.get("/payments/invoices");

/**
 * Método de pagamento vigente (nunca expõe o número completo do cartão).
 * Backend: GET /api/payments/payment-method.
 * Retorno: { billingType, brand?, last4? }.
 */
export const getPaymentMethod = () => api.get("/payments/payment-method");
